import { FC } from 'react';
import { Chat } from '../../types';
import { ChatHeader } from '../ChatHeader/ChatHeader';
import { ChatMessageList } from '../ChatMessageList/ChatMessageList';
import { ChatMessageInput } from '../ChatMessageInput/ChatMessageInput';

interface ChatConversationProps {
  chat: Chat;
  currentUserId: number;
  onSendMessage: (text: string) => void;
  onBack?: () => void;
  isSending?: boolean;
  hideHeader?: boolean;
}

export const ChatConversation: FC<ChatConversationProps> = ({
  chat,
  currentUserId,
  onSendMessage,
  onBack,
  isSending = false,
  hideHeader = false,
}) => {
  return (
    <div className="flex-1 flex flex-col bg-white h-full">
      {!hideHeader && <ChatHeader chat={chat} currentUserId={currentUserId} onBack={onBack} />}
      <ChatMessageList messages={chat.messages} currentUserId={currentUserId} />
      <ChatMessageInput onSend={onSendMessage} disabled={isSending} />
    </div>
  );
};
